import { render, staticRenderFns } from "./CreateKitOrder.vue?vue&type=template&id=630bd99c&scoped=true&"
import script from "./CreateKitOrder.vue?vue&type=script&lang=js&"
export * from "./CreateKitOrder.vue?vue&type=script&lang=js&"
import style0 from "./CreateKitOrder.vue?vue&type=style&index=0&id=630bd99c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630bd99c",
  null
  
)

export default component.exports